var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.datos
    ? _c("div", { staticClass: "log-datos" }, [
        _c("div", [
          _vm._v("\n    Creado por "),
          _c("strong", [_vm._v(_vm._s(_vm.datos._user_created))]),
          _vm._v("\n    el "),
          _c("strong", [
            _vm._v(_vm._s(_vm.$datetime.datetimeLiteral(_vm.datos._created_at)))
          ])
        ]),
        _vm._v(" "),
        _vm.datos._user_updated
          ? _c("div", [
              _vm._v("\n    Última edición por "),
              _c("strong", [_vm._v(_vm._s(_vm.datos._user_updated))]),
              _vm._v("\n    el "),
              _c("strong", [
                _vm._v(
                  _vm._s(_vm.$datetime.datetimeLiteral(_vm.datos._updated_at))
                )
              ])
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7536acf0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7536acf0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/usuario/LogDatos.vue
// module id = null
// module chunks = 